import styled from 'styled-components';

export const ExternalReferenceContainer = styled.div`
  margin-top: 0.75rem;
`;

export const ExternalReferenceTitle = styled.div`
  color: ${({ theme }) => theme.labelColor};
  font-weight: 600;
  margin-bottom: 0.25rem;
`;
